import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="min-h-screen flex flex-col bg-slate-50" data-id="element-97">
      <Navbar data-id="element-98" />
      <main className="flex-grow" data-id="element-99">{children}</main>
      <Footer data-id="element-100" />
    </div>;
};
export default Layout;